import { inject } from '@angular/core';
import { type CanActivateFn, Router } from '@angular/router';
import { PlatformContextService } from '../platform/platform-context.service';
import { PermissionService } from './permission.service';

export const PERMISSION_ROUTE_DATA_KEY = 'permission' as const;

export interface PermissionRouteData {
  readonly permission: string;
}

export const permissionGuard: CanActivateFn = async (route) => {
  const permissionService = inject(PermissionService);
  const platformContext = inject(PlatformContextService);
  const router = inject(Router);
  const requiredPermission = route.data[PERMISSION_ROUTE_DATA_KEY];

  if (typeof requiredPermission !== 'string' || requiredPermission.trim().length === 0) {
    return router.createUrlTree(['/']);
  }

  if (!permissionService.isLoaded() && !(await permissionService.load())) {
    platformContext.markApplicationError();
    return false;
  }

  // Navigation visibility is UX only; backend authorization remains authoritative.
  return permissionService.hasPermission(requiredPermission)
    ? true
    : router.createUrlTree(['/access-denied']);
};
